import React, { useEffect, useState } from 'react';

export const MobileTest: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const updateDimensions = () => {
      setWindowWidth(window.innerWidth);
      setIsMobile(window.innerWidth < 768);
    };
    
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Mobile Test Page</h1>
      
      {/* Debug Info */}
      <div className="bg-gray-100 p-4 rounded-lg mb-6">
        <h2 className="font-semibold mb-2">Debug Information:</h2>
        <p>Window Width: {windowWidth}px</p>
        <p>Is Mobile (JS): {isMobile ? 'YES' : 'NO'}</p>
        <p>User Agent: {navigator.userAgent}</p>
      </div>

      {/* Tailwind Responsive Test */}
      <div className="mb-6">
        <h2 className="font-semibold mb-2">Tailwind Responsive Classes:</h2>
        
        <div className="bg-red-500 md:bg-green-500 text-white p-4 rounded mb-2">
          This should be RED on mobile, GREEN on desktop
        </div>
        
        <div className="block md:hidden bg-blue-500 text-white p-4 rounded mb-2">
          This should ONLY show on MOBILE
        </div>
        
        <div className="hidden md:block bg-purple-500 text-white p-4 rounded mb-2">
          This should ONLY show on DESKTOP
        </div>
      </div>

      {/* JavaScript Mobile Detection */}
      <div className="mb-6">
        <h2 className="font-semibold mb-2">JavaScript Mobile Detection:</h2>
        {isMobile ? (
          <div className="bg-orange-500 text-white p-4 rounded">
            JavaScript detects: MOBILE DEVICE
          </div>
        ) : (
          <div className="bg-teal-500 text-white p-4 rounded">
            JavaScript detects: DESKTOP DEVICE
          </div>
        )}
      </div>

      {/* CSS Media Query Test */}
      <div className="mb-6">
        <h2 className="font-semibold mb-2">CSS Media Query Test:</h2>
        <div className="media-query-test bg-gray-300 p-4 rounded">
          Check CSS (should change color based on screen size)
        </div>
      </div>
      
      <style>{`
        @media (max-width: 767px) {
          .media-query-test {
            background-color: #f59e0b !important;
            color: white;
          }
          .media-query-test::after {
            content: " - MOBILE VIEW";
          }
        }
        @media (min-width: 768px) {
          .media-query-test {
            background-color: #10b981 !important;
            color: white;
          }
          .media-query-test::after {
            content: " - DESKTOP VIEW";
          }
        }
      `}</style>
    </div>
  );
};